import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./actions/AuthSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import performanceReducer from "./actions/performanceSlice";
import userReducer from './actions/UsersSlice'
export const store = configureStore({
  reducer: {
    auth: authReducer,
    performance: performanceReducer,
    users:userReducer,
  },
});

setupListeners(store.dispatch);
